export default __webpack_public_path__ + "static/media/245.787d59d7.jpg";